import {
  createCatalogEndpoint,
  createCrudEndpoints,
  createNestedCrudEndpoints,
} from '@/core/utils'
import {
  TDashboard,
  TAdvisors,
  TOrigins,
  TCampaigns,
  TStatuses,
  TProject,
  TCatalogs,
  TDashboardDinamic,
} from './types'

import { TLot, TLots } from '../projects'

export const serviceConfig = {
  model: 'dashboard',
  version: 'v2',
  dashboardDynamic: {
    model: 'dashboard-dynamic',
    version: 'v1',
  },
  projects: {
    model: 'projects',
    version: 'v1',
  },
  advisors: {
    model: 'advisors',
    version: 'v1',
  },
  origins: {
    model: 'origins',
    version: 'v1',
  },
  campaigns: {
    model: 'campaigns',
    version: 'v1',
  },
  statuses: {
    model: 'lead-status',
    version: 'v1',
  },
  lots: {
    model: 'lots',
    version: 'v1',
  },
  socialNetworks: {
    model: 'social-networks',
    version: 'v1',
  },
  referrals: {
    model: 'referrals',
    version: 'v1',
  },
  catalogs: {
    model: 'catalogs',
    version: 'v1',
  },
}

const {
  projects,
  advisors,
  origins,
  campaigns,
  statuses,
  lots,
  socialNetworks,
  referrals,
  dashboardDynamic,
  catalogs,
} = serviceConfig

const moduleServiceHandlers = createCrudEndpoints<TDashboard, TDashboard>(
  serviceConfig.model,
  serviceConfig.version,
)
const dashboardDinamicServiceHandler = createCrudEndpoints<
  TDashboardDinamic,
  TDashboardDinamic
>(dashboardDynamic.model, dashboardDynamic.version)

const advisorsServiceHandler = createCatalogEndpoint<TAdvisors>(
  advisors.model,
  advisors.version,
)

const originsServiceHandler = createCatalogEndpoint<TOrigins>(
  origins.model,
  origins.version,
)

const campaignsServiceHandler = createCatalogEndpoint<TCampaigns>(
  campaigns.model,
  campaigns.version,
)

const statusesServiceHandler = createCatalogEndpoint<TStatuses>(
  statuses.model,
  statuses.version,
)

const projectsServiceHandler = createCatalogEndpoint<TProject[]>(
  projects.model,
  projects.version,
)

const leadsLotsServiceHandler = createCatalogEndpoint<TLots[]>(
  lots.model,
  lots.version,
)

const lotsServiceHandler = createCatalogEndpoint<TLots>(
  lots.model,
  lots.version,
)

const socialNetworksServiceHandler = createCatalogEndpoint<TCatalogs>(
  socialNetworks.model,
  socialNetworks.version,
)

const projectsLotsService = createNestedCrudEndpoints<TLots, TLot>(
  projects.model,
  lots.model,
  lots.version,
)

const referralsServiceHandler = createCatalogEndpoint<TCatalogs>(
  referrals.model,
  referrals.version,
)
const categoriesCatalog = createCatalogEndpoint<TCatalogs>('', catalogs.version)

const catalogServiceHandlers = {
  statusesServiceHandler,
  campaignsServiceHandler,
  originsServiceHandler,
  advisorsServiceHandler,
  projectsServiceHandler,
  leadsLotsServiceHandler,
  lotsServiceHandler,
  projectsLotsService,
  socialNetworksServiceHandler,
  referralsServiceHandler,
  categoriesCatalog,
}

export {
  moduleServiceHandlers,
  catalogServiceHandlers,
  dashboardDinamicServiceHandler,
}
